﻿import request from '@/config/axios'

// 店铺配置 VO
export interface ShopConfigVO {
  id?: string | number
  shopId: string | number
  propertyType: number // 0酒店 1民宿 2客栈 3公寓 4青旅 5度假村
  operationMode: 'SELF_OPERATED' | 'PLATFORM_MANAGED' | 'THIRD_PARTY'
  autoSettle: number
  settleCycle: 'INSTANT' | 'DAILY' | 'WEEKLY' | 'MONTHLY'
  commissionRate: number
  status: number
  checkInTime: string
  checkOutTime: string
  hourlyRoomEnabled: number
  multiGuestEnabled: number
  autoConfirm: number
  oversellLimit: number
  cancelPolicy: string
  depositPolicy: string
  lateCheckoutFee: number
  earlyCheckinFee: number
  childPolicy: string
  petPolicy: string
  remark?: string
  createTime?: Date
}

// 获取店铺配置分页
export const getShopConfigPage = (params: any) => {
  return request.get({ url: '/hotel/shop-config/page', params })
}

// 获取店铺配置详情
export const getShopConfig = (id: string | number) => {
  return request.get({ url: '/hotel/shop-config/get?id=' + id })
}

// 根据店铺ID获取配置
export const getShopConfigByShopId = (shopId: string | number) => {
  return request.get({ url: '/hotel/shop-config/get-by-shop?shopId=' + shopId })
}

// 创建店铺配置
export const createShopConfig = (data: ShopConfigVO) => {
  return request.post({ url: '/hotel/shop-config/create', data })
}

// 更新店铺配置
export const updateShopConfig = (data: ShopConfigVO) => {
  return request.put({ url: '/hotel/shop-config/update', data })
}

// 删除店铺配置
export const deleteShopConfig = (id: string | number) => {
  return request.delete({ url: '/hotel/shop-config/delete?id=' + id })
}
